import utils from 'utils'
class licenseCtrl {
    constructor($scope, logger, Upload, $timeout, $state) {


        $scope.uploadFiles = function uploadFiles(file, errFiles) {
            utils.loading('license导入中')
            $scope.f = file
            $scope.errFile = errFiles && errFiles[0]
            if (file) {
                file.upload = Upload.upload({
                    url: `${host.etcloud}settings/sysOwnerInfo/importClientLic`,
                    data: {
                        licenseFile: file,
                        // name:$scope.clientLicFile
                    },
                })

                file.upload.then((response) => {
                    $timeout(() => {
                        file.result = response.data
                        if (file.result.success) {
                            if (file.result.message == null) file.result.message = '导入license成功'
                            logger.logSuccess(file.result.message)
                            $timeout(() => {
                                // $location.path('/index/licenseoperate').replace()
                                $scope.$emit('logoChange')
                                $state.go('login')
                            }, 1000)
                        } else {
                            logger.logError(file.result.message)
                        }
                    })
                }, (response) => {
                    logger.logError(response.data.message)
                }, (evt) => {
                    file.progress = Math.min(100, parseInt((100.0 * evt.loaded) / evt.total, 10))
                }).finally(()=>{
                    utils.loaded()
                })
            }
        }

    }
}
licenseCtrl.$inject = ['$scope', 'logger', 'Upload', '$timeout', '$state']
export default licenseCtrl


// WEBPACK FOOTER //
// ./src/app/main/license/licenseCtrl.js